import styled from 'vue-styled-components'

export default styled.div`
    background-color: #FFFFFF;
    margin-top: 0px;
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #efefef;
    & .ranges-form{
        & .header {
            border-bottom: 1px solid #efefef;
        }
    }
    & .ranges-discount-content{
        margin-top: 1rem;
    }
    & .table-ranges {
        & tr {
            cursor: pointer;
        }    
    }
`;
